// Collection Image Reset - Force styling to remove space above/below images
document.addEventListener('DOMContentLoaded', function() {
  console.log('Collection image reset script loaded');
  
  // Functie om de stijlen toe te passen
  function applyImageContainerStyles() {
    console.log('Applying collection image reset styles');
    
    // Direct een stylesheet toevoegen met !important regels
    if (!document.getElementById('collection-image-reset-styles')) {
      const styleElement = document.createElement('style');
      styleElement.id = 'collection-image-reset-styles';
      styleElement.innerHTML = `
        /* Reset voor product afbeeldingen */
        .premium-product-card,
        .premium-product-image-container,
        .premium-product-image-container img,
        .premium-product-image-container .premium-product-image,
        .premium-product-image-container .premium-product-second-image,
        .premium-product-info {
          box-sizing: border-box !important;
          margin: 0 !important;
          padding: 0 !important;
        }
  
        .premium-product-image-container {
          padding-top: 100% !important;
          margin: 0 !important;
          height: 0 !important;
          background: none !important;
          overflow: hidden !important;
          position: relative !important;
          border-radius: 8px 8px 0 0 !important;
          width: 100% !important;
        }
  
        .premium-product-image-container img,
        .premium-product-image-container .premium-product-image,
        .premium-product-image-container .premium-product-second-image {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          width: 100% !important;
          height: 100% !important;
          object-fit: contain !important;
          margin: 0 !important;
          padding: 0 !important;
          transition: opacity 0.7s cubic-bezier(0.25, 0.1, 0.25, 1) !important;
        }
        
        .premium-product-image-container .premium-product-second-image {
          opacity: 0 !important;
        }
        
        .premium-product-image-container:hover .premium-product-image {
          opacity: 0 !important;
        }
        
        .premium-product-image-container:hover .premium-product-second-image {
          opacity: 1 !important;
        }
  
        .premium-product-info {
          padding: 15px !important;
          margin-top: 0 !important;
          border-radius: 0 0 8px 8px !important;
          width: 100% !important;
        }
      `;
      document.head.appendChild(styleElement);
    }
    
    // Optimalisatie: We gebruiken een documentFragment voor alle elementen
    const imageContainers = document.querySelectorAll('.premium-product-image-container');
    console.log(`Found ${imageContainers.length} image containers`);
    
    if (imageContainers.length > 0) {
      // Maak alle CSS aanpassingen in één keer
      const containerCSS = `
        padding-top: 100% !important;
        margin: 0 !important;
        height: 0 !important;
        background: none !important;
        overflow: hidden !important;
        position: relative !important;
        border-radius: 8px 8px 0 0 !important;
        width: 100% !important;
      `;
      
      const imageCSS = `
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
        margin: 0 !important;
        padding: 0 !important;
        transition: opacity 0.7s cubic-bezier(0.25, 0.1, 0.25, 1) !important;
      `;
      
      const secondImageCSS = imageCSS + `opacity: 0 !important;`;
      
      // Optimalisatie: Gebruik één keer CSS-toewijzing per type
      imageContainers.forEach(container => {
        container.style.cssText = containerCSS;
        
        // Zoek alle afbeeldingselementen in de container
        const mainImages = container.querySelectorAll('img:not(.premium-product-second-image)');
        const secondImages = container.querySelectorAll('.premium-product-second-image');
        
        mainImages.forEach(img => {
          img.style.cssText = imageCSS;
          img.classList.add('premium-product-image');
        });
        
        secondImages.forEach(img => {
          img.style.cssText = secondImageCSS;
        });
      });
      
      // Product info styling consistentie
      const productInfos = document.querySelectorAll('.premium-product-info');
      console.log(`Found ${productInfos.length} product info elements`);
      
      productInfos.forEach(info => {
        info.style.cssText = `
          padding: 15px !important;
          margin-top: 0 !important;
          border-radius: 0 0 8px 8px !important;
          width: 100% !important;
        `;
      });
    }
  }
  
  // Pas de stijlen direct toe
  applyImageContainerStyles();
  
  // Pas de stijlen ook toe na een korte vertraging (voor dynamisch geladen content)
  setTimeout(applyImageContainerStyles, 500);
  setTimeout(applyImageContainerStyles, 1500); // Extra check voor traag ladende content
  
  // Observeer DOM veranderingen en pas stijlen toe wanneer nieuwe elementen worden toegevoegd
  const observer = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Er zijn nieuwe elementen toegevoegd, pas stijlen toe
        setTimeout(applyImageContainerStyles, 100);
        break;
      }
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Pas stijlen ook toe na het laden van elke afbeelding
  document.addEventListener('load', function(event) {
    if (event.target.tagName === 'IMG' && 
       (event.target.closest('.premium-product-image-container'))) {
      setTimeout(applyImageContainerStyles, 100);
    }
  }, true);
  
  // Als de pagina ajax-filtering gebruikt
  document.addEventListener('shopify:section:load', applyImageContainerStyles);
  
  // Voeg een publieke functie toe zodat andere scripts dit kunnen aanroepen
  window.resetCollectionImages = applyImageContainerStyles;
}); 